module.exports = __webpack_public_path__ + "img/_polices.3a6e1441.png";